module.exports = __webpack_public_path__ + "img/96.f1759e9.png";